// * Import pages
import Dashboard from "../pages/Dashboard/Dashboard";
import Profile from "../pages/Profile/Profile";
import JobDetail from "../pages/JobDetail/JobDetail";
import ExecutionDetail from "../pages/ExecutionDetail/ExecutionDetails";
import ExecutionsPage from "../pages/ExecutionsPage/ExecutionsPage";
import JobsPage from "../pages/JobsPage/JobsPage";
import CreateJob from "../pages/CreateJob/CreateJob";
import PricingPage from "../pages/Pricing/Pricing";
import PaymentRedirectPage from "../pages/PaymentRedirect/PaymentRedirect";
import AlertsPage from "../pages/AlertPage/AlertPage";
import FeedbackPage from "../pages/FeedbackPage/FeedbackPage";
import OnboardingWelcome from "../pages/Onboarding/OnboardingWelcome";
import OnboardingWizard from "../pages/Onboarding/OnboardingWizard";
import Recent from "../pages/Recent/Recent";

// * Import Icons (Heroicons — single set for whole product)
import {
  Squares2X2Icon,
  FunnelIcon,
  ListBulletIcon,
  BellIcon,
  CreditCardIcon,
  UserCircleIcon,
  ChatBubbleLeftRightIcon,
  CalendarDaysIcon,
} from "@heroicons/react/24/outline";

const PROTECTED_ROUTES = [
  {
    fullScreen: false,
    includedInSidebar: true,
    link: "/dashboard",
    name: "Dashboard",
    component: <Dashboard />,
    icon: <Squares2X2Icon className="h-5 w-5" />,
    key: 1,
  },
  {
    fullScreen: false,
    includedInSidebar: true,
    link: "/recent",
    name: "Recent",
    component: <Recent />,
    icon: <CalendarDaysIcon className="h-5 w-5" />,
    key: "recent",
  },
  {
    fullScreen: false,
    includedInSidebar: true,
    link: "/jobs",
    name: "Scouts",
    component: <JobsPage />,
    icon: <FunnelIcon className="h-5 w-5" />,
    key: 2,
  },
  {
    fullScreen: false,
    includedInSidebar: false,
    link: "/executions",
    name: "Executions",
    component: <ExecutionsPage />,
    icon: <ListBulletIcon className="h-5 w-5" />,
    key: 3,
  },
  {
    fullScreen: false,
    includedInSidebar: true,
    link: "/alerts",
    name: "Alerts",
    component: <AlertsPage />,
    icon: <BellIcon className="h-5 w-5" />,
    key: 9,
  },
  {
    fullScreen: false,
    includedInSidebar: true,
    link: "/pricing",
    name: "Pricing",
    component: <PricingPage />,
    icon: <CreditCardIcon className="h-5 w-5" />,
    key: 4,
  },
  {
    fullScreen: false,
    includedInSidebar: true,
    link: "/profile",
    name: "Profile",
    component: <Profile />,
    icon: <UserCircleIcon className="h-5 w-5" />,
    key: 5,
  },
  {
    fullScreen: false,
    includedInSidebar: true,
    link: "/feedback",
    name: "Feedback",
    component: <FeedbackPage />,
    icon: <ChatBubbleLeftRightIcon className="h-5 w-5" />,
    key: 10,
  },
  {
    fullScreen: false,
    includedInSidebar: false,
    link: "/job-detail",
    name: "Job Detail",
    component: <JobDetail />,
    key: 6,
  },
  {
    fullScreen: true,
    includedInSidebar: false,
    link: "/execution-detail",
    name: "Execution Detail",
    component: <ExecutionDetail />,
    key: 6,
  },
  {
    fullScreen: true,
    includedInSidebar: false,
    link: "/onboarding",
    name: "Onboarding",
    component: <OnboardingWelcome />,
    key: "onboarding",
  },
  {
    fullScreen: true,
    includedInSidebar: false,
    link: "/onboarding/create-matcher",
    name: "Onboarding Wizard",
    component: <OnboardingWizard />,
    key: "onboarding-wizard",
  },
  {
    fullScreen: false,
    includedInSidebar: false,
    link: "/create-job",
    name: "Create Job",
    component: <CreateJob />,
    key: 7,
  },
  {
    fullScreen: false,
    includedInSidebar: false,
    link: "/payment-redirect",
    name: "Payment Redirect",
    component: <PaymentRedirectPage />,
    key: 8,
  },
];

export default PROTECTED_ROUTES;
